/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Mobile Nav Bar.
 */

import React from "react";
import { MobileMenuToggleButton } from "./MobileMenuToggleButton";
import { MobileNavBarBrand } from "./MobileNavBarBrand";
import { MobileNavBarButtons } from "./MobileNavBarButtons";
import { MobileNavBarTabs } from "./MobileNavBarTabs";
import Ticker from "../../Ticker";

const MobileMenuState = {
  CLOSED: "closed",
  OPEN: "open",
};

const MobileMenuIcon = {
  CLOSE: "close",
  MENU: "menu",
};

export const MobileNavBar = () => {
  const [mobileMenuState, setMobileMenuState] = React.useState(
    MobileMenuState.CLOSED
  );
  const [mobileMenuIcon, setMobileMenuIcon] = React.useState(
    MobileMenuIcon.MENU
  );

  const isMobileMenuOpen = () => {
    return mobileMenuState === MobileMenuState.OPEN;
  };

  const closeMobileMenu = () => {
    document.body.classList.remove("mobile-scroll-lock");
    setMobileMenuState(MobileMenuState.CLOSED);
    setMobileMenuIcon(MobileMenuIcon.MENU);
  };

  const openMobileMenu = () => {
    document.body.classList.add("mobile-scroll-lock");
    setMobileMenuState(MobileMenuState.OPEN);
    setMobileMenuIcon(MobileMenuIcon.CLOSE);
  };

  const toggleMobileMenu = () => {
    if (isMobileMenuOpen()) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  };

  return (

    <div className="MobileNavBar__container">
      <nav className="MobileNavBar">

        <MobileNavBarBrand handleClick={closeMobileMenu} />

        <MobileMenuToggleButton
          icon={mobileMenuIcon}
          handleClick={toggleMobileMenu}
        />

        {isMobileMenuOpen() && (
          <div className="MobileNavBar__menu">
            <MobileNavBarTabs handleClick={closeMobileMenu} />
            <MobileNavBarButtons />
          </div>
        )}
      </nav>
      </div>
  );
};
